module.exports = __webpack_public_path__ + "static/img/solo_vip.94a1fd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/svg/solo_vip.png
// module id = wCY+
// module chunks = 16